import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Toast } from '@10d/tend-ui/primitives';

import {
  deleteGaranteeLetter,
  getGaranteeLetter,
  getHistoryGaranteeLetter,
  postGaranteeLetter,
  putConfirmGaranteeLetter,
} from '../thunks';

import { GuaranteeLetterState } from 'features/EngineeringNetStatus/EngineeringInfo/GuaranteeLetter/types';

const initialState: GuaranteeLetterState = {
  currentRequestId: undefined,
  history: [],
  historyLoading: false,
  letter: undefined,
  loading: false,
};

const reset: CaseReducer<GuaranteeLetterState> = () => initialState;

const resetHistory: CaseReducer<GuaranteeLetterState, PayloadAction> = state => {
  state.history = [];
};

export const guaranteeLetterSlice = createSlice({
  name: 'EN_guaranteeLetter',
  initialState,
  reducers: {
    reset,
    resetHistory,
  },
  extraReducers: builder => {
    builder
      // getGaranteeLetter
      .addCase(getGaranteeLetter.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(getGaranteeLetter.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.letter = payload;
      })
      .addCase(getGaranteeLetter.rejected, (state, action) => {
        const { requestId } = action.meta;

        if (state.loading === true && state.currentRequestId === requestId) {
          state.loading = false;
        }
      })

      // postGaranteeLetter
      .addCase(postGaranteeLetter.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(postGaranteeLetter.fulfilled, (state, { payload }) => {
        state.loading = false;

        if (payload) {
          state.letter = payload;
        }
      })
      .addCase(postGaranteeLetter.rejected, (state, action) => {
        const { requestId } = action.meta;

        if (state.loading === true && state.currentRequestId === requestId) {
          state.loading = false;
        }
      })

      // deleteGaranteeLetter
      .addCase(deleteGaranteeLetter.fulfilled, state => {
        state.letter = {};
      })

      // putConfirmGaranteeLetter
      .addCase(putConfirmGaranteeLetter.fulfilled, state => {
        state.letter = {
          ...state.letter,
          isComplete: true,
        };

        Toast.success({
          message: 'Исполнение гарантийного письма подтверждено',
        });
      })

      // getHistoryGaranteeLetter
      .addCase(getHistoryGaranteeLetter.pending, (state, action) => {
        state.historyLoading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(getHistoryGaranteeLetter.fulfilled, (state, { payload }) => {
        state.historyLoading = false;
        state.history = payload;
      })
      .addCase(getHistoryGaranteeLetter.rejected, (state, action) => {
        const { requestId } = action.meta;

        if (state.historyLoading === true && state.currentRequestId === requestId) {
          state.historyLoading = false;
        }
      });
  },
});

export const { reset: setGuaranteeLetterReset, resetHistory: resetGuaranteeHistory } =
  guaranteeLetterSlice.actions;
